import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { UtilsService } from "./utils.services";
import { SessionService } from "./session.service";

@Injectable({ providedIn: "root" })
export class TutorialService {
  private tutorialPopupSource = new Subject<any>();
  showAutomatedTutorials: BehaviorSubject<string> = new BehaviorSubject<string>(
    "-"
  );
  openTutorialPopupCalled$ = this.tutorialPopupSource.asObservable();
  baseUrl = environment.baseUrl + "/api";
  isTutorialDone = true;
  pageToggle: boolean = false;
  isShown = {};
  httpOptions = {};

  constructor(
    private httpClient: HttpClient,
    private utils: UtilsService,
    private sessionService: SessionService
  ) {
    this.httpOptions = this.utils.httpOptions;
  }

  markTutorialAsDone() {
    this.isTutorialDone = true;
    this.httpClient
      .put(
        environment.baseUrl +
          `/user-microservice/user/${this.sessionService.UserGUID}/lab-tutorial`,
        {},
        this.httpOptions
      )
      .subscribe();
  }

  setTuorialSteps(userId: number, tutorial: string) {
    this.isTutorialDone = true;
    this.httpClient
      .post(
        environment.baseUrl + `/user-microservice/user/${userId}/on-boarding`,
        { tutorialName: tutorial },
        this.httpOptions
      )
      .subscribe();
  }

  getOnboardingDetails(UserID: any): Observable<any> {
    return this.httpClient.get(
      environment.baseUrl + `/user-microservice/user/${UserID}`,
      this.httpOptions
    );
  }

  updateDemoPageToggle(userGuid: string, toggle: string) {
    return this.httpClient.put(
      this.baseUrl + `/user-microservice/user/${userGuid}/page-toggle`,
      { status: toggle },
      this.httpOptions
    );
  }

  open(position, heading: string, content: string, arrowClass, options = {}) {
    let element, top, left;

    if (position.isId) {
      element = document.getElementById(position.elementId);
    }
    if (position.isClass) {
      element = document.getElementsByClassName(position.className)[
        position.classIndex || 0
      ];
    }
    if (!element) {
      return;
    }

    let react = element.getBoundingClientRect();

    top = react.top + position.offsetTop;
    left = react.left + position.offsetLeft;

    if (!this.isTutorialDone && !this.isShown[content]) {
      this.isShown[content] = true;
      this.tutorialPopupSource.next({
        top,
        left,
        heading,
        content,
        arrowClass,
        options,
      });
      if (options["isLastStep"]) {
        this.markTutorialAsDone();
      }
    }
  }
}
